<template>
  <div class="fly-history-wrap">
    <div class="title-bar" @click="goToLookMap(null)">
      <div class="img"></div>
      <div class="titles">
        <div class="item">
          实飞面积 <span class="number">{{ flyData.total_work_mu }}亩</span>
        </div>
        <div class="item">
          无人机共<span class="number">{{ flyData.total_plane_count }}</span
          >台
        </div>
        <div class="item time">
          {{ flyData.total_start_time }} - {{ flyData.total_end_time }}
        </div>
      </div>
      <van-icon name="arrow" class="right" />
    </div>
    <ul class="fly-ul">
      <li
        v-for="(item, index) in flyData.list"
        :key="index"
        @click="goToLookMap(item.user_id)"
      >
        <div class="left">
          <van-image
            width="40"
            height="40"
            class="image"
            round
            :src="item.avatar"
          ></van-image>
          <div class="name">{{ item.nickname }}</div>
        </div>
        <div class="mid">
          <div class="item">
            实飞面积 <span class="number">{{ item.work_mu }}亩</span>
          </div>
          <div class="item">
            无人机共<span class="number">{{ item.plane_count }}</span
            >台
          </div>
          <div class="item time">
            {{ item.start_time }} — {{ item.end_time }}
          </div>
        </div>
        <van-icon name="arrow" class="right" />
      </li>
    </ul>
  </div>
</template>
<script>
import { mapState } from "vuex";
import axios from "../../http";
export default {
  name: "fly_history",
  components: {},
  props: {},
  data() {
    return {
      flyData: ""
    };
  },
  computed: {
    ...mapState(["token"])
  },
  watch: {},
  mounted() {
    this.getFlyData();
  },
  destroyed() {},
  methods: {
    getFlyData() {
      axios
        .fetchPost("/api/order/fly_detail", {
          order_sn: this.$route.query.order_sn,
          token: this.token
        })
        .then(res => {
          let data = res.data;
          if (data.code == 200) {
            this.flyData = data.data;
          }
        })
        .catch(error => {
          console.log("error :>> ", error);
        });
    },
    goToLookMap(user_id) {
      //查看轨迹
      this.$router.push({
        path: "/maps",
        query: {
          order_sn: this.$route.query.order_sn,
          user_id: user_id
        }
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.fly-history-wrap
  text-align left
  .title-bar
    display flex
    padding 12px 13px
    align-items center
    font-family Microsoft YaHei
    font-weight 400
    background #fff
    .img
      width 40px
      height 40px
      background url('./fly.png') no-repeat
      background-size contain
      margin-right 15px
    .titles
      flex 1
      font-size 12px
      color #282828
      line-height 1.2
      .item
        margin-bottom 5px
        .number
          font-size 14px
          color #282828
          margin 0 3px
      .time
        color #666666
    .icon
      color #BEBEBE
    .right
      width 20px
      color #BEBEBE
  .fly-ul
    margin-top 10px
    padding 0 12px
    & > li
      display flex
      background #ffffff
      padding 12px 13px
      align-items center
      font-family Microsoft YaHei
      font-weight 400
      margin-bottom 10px
      .right
        width 20px
        color #BEBEBE
      .left
        width 67px
        background-size contain
        margin-right 15px
        text-align center
        .image
          border-radius 100%
        .name
          font-size 13px
          color #282828
      .mid
        flex 1
        font-size 12px
        color #282828
        line-height 1.2
        .item
          margin-bottom 5px
          .number
            font-size 14px
            color #282828
            margin 0 3px
        .time
          color #666666
      .icon
        color #BEBEBE
</style>
